export default "__VITE_ASSET__Cc30DAaj__"